document.addEventListener('DOMContentLoaded', () => {
  const slideshowExists = document.querySelector('.slideshow');
  if (!slideshowExists) return;

  // Swiper yoksa hiç başlatma
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper not loaded, slideshow skipped');
    return;
  }

  (function () {
    let started = false;

    function initSlideshow() {
      if (started) return;
      started = true;

      document.querySelectorAll(".slideshow-section").forEach((section) => {
        if (section.classList.contains("slider_started")) return;

        const box = section.querySelector(".slideshow");
        if (!box || !box.dataset) return;

        section.classList.add("slider_started");

        const id = section.id;
        const delay = Number(box.dataset.delay || 5) * 1000;
        const speed = Number(box.dataset.speed || 0.5) * 1000;
        const autoplay = box.dataset.autoplay === 'true';
        const stopAutoplay = box.dataset.stopAutoplay === 'true';

        const swiperParams = {
          loop: false,
          speed,
          effect: box.dataset.effect || 'slide',
          parallax: box.dataset.parallax === 'true',
          autoHeight: false,
          keyboard: true,
          pagination: {
            el: `#${id} .swiper-pagination`,
            clickable: true
          },
          autoplay: autoplay
            ? { delay, disableOnInteraction: false, pauseOnMouseEnter: stopAutoplay }
            : false
        };

        const swiperEl = section.querySelector(".slideshow__swiper");
        if (!swiperEl) return;

        const swiper = new Swiper(swiperEl, swiperParams);

        function updateColorScheme() {
          const schemeEl = section.querySelector('[data-color-scheme]');
          if (!schemeEl || !schemeEl.dataset.colorScheme) return;
          document.documentElement.setAttribute(
            'data-scheme',
            schemeEl.dataset.colorScheme
          );
        }

        swiper.on("slideChange", updateColorScheme);
        updateColorScheme();
      });
    }

    // Lazy init
    ['scroll', 'touchstart', 'click', 'mousemove'].forEach(evt => {
      window.addEventListener(evt, initSlideshow, {
        once: true,
        passive: true
      });
    });

    // Shopify section reload
    document.addEventListener("shopify:section:load", () => {
      started = false;
      initSlideshow();
    });
  })();
});
